<template>
  <div class="f-aboutUs">
    <h2 class="title-container clickable" @click="loadSignPetition">#AlpFoodway</h2>
    <div class="embed-frame">
      <b-embed type="iframe"
               aspect="16by9"
               controls
               poster="poster.png"
               src="https://www.youtube.com/embed/s8AWxn-_3l0?rel=0"
               allowfullscreen></b-embed>
    </div>
  </div>
</template>

<script>
  import SignPetitionPage from '../signPetitionPageComponents/SignPetitionPage'

  export default {
    name: 'AboutUs',
    computed: {
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      }
    },
    methods: {
      loadSignPetition () {
        this.$store.commit('setCurrentView', SignPetitionPage)
        this.$router.push('/sign-petition')
      }
    }
  }
</script>

<style scoped>

  .f-aboutUs {
    /*background-color: whitesmoke;*/
    border-radius: 8px;
    height: 100%;
    padding: 3% 3% 3%;
  }

  .embed-frame {
    /*pointer-events: none;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/AboutUs.vue